import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/*
 * Visible breadcrumbs (SEO Batch B, Part 1.5). `crumbs` is the same [[name, path], …] list the page's
 * BreadcrumbList JSON-LD is built from (seo/schema.js breadcrumbSchema), so the two can never drift:
 * every item but the last is a real <a href> (react-router <Link>), the last is the current page.
 * `tone` picks light-on-dark (inside the dark page heroes) or dark-on-light (the landing page strip).
 */
export const Breadcrumbs = ({ crumbs, tone = 'dark', className = '', testId = 'breadcrumbs' }) => {
  if (!crumbs || crumbs.length < 2) return null;
  const onDark = tone === 'dark';
  const link = onDark ? 'text-[rgba(244,241,234,0.72)] hover:text-white' : 'text-[#61676E] hover:text-[#121417]';
  const current = onDark ? 'text-white' : 'text-[#121417]';
  const sep = onDark ? 'text-[rgba(244,241,234,0.4)]' : 'text-[#B5AFA3]';
  return (
    <nav aria-label="Breadcrumb" className={`font-mono-idb text-[11px] sm:text-xs uppercase tracking-[0.14em] ${className}`} data-testid={testId}>
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1 list-none m-0 p-0">
        {crumbs.map(([name, path], i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={path} className="inline-flex items-center gap-1.5 min-w-0">
              {last
                ? <span aria-current="page" className={`${current} truncate max-w-[70vw] sm:max-w-none normal-case tracking-normal font-sans text-xs sm:text-sm`} data-testid={`${testId}-current`}>{name}</span>
                : <Link to={path} className={`${link} transition-colors duration-150 max-md:min-h-11 max-md:inline-flex max-md:items-center`} data-testid={`${testId}-link-${path === '/' ? 'home' : path.replace(/^\//, '').replace(/\//g, '-')}`}>{name}</Link>}
              {!last && <ChevronRight className={`h-3 w-3 ${sep}`} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
